import Axios from 'axios';

export const POP = Axios.create({
    // baseURL: '//dev.pop-api.propertylogic.net/api/v1/'
    baseURL: '//pop-api.propertylogic.net/api/v1/'
});

export const POM = Axios.create({
    baseURL: '/api/'
});



// WEBPACK FOOTER //
// ./src/http-common.js